/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_STAFF_GET
 */
export const getStaffMemberByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getStaffMemberByIdResponseAddressAddressLine1Max = 255;

export const getStaffMemberByIdResponseAddressAddressLine2Max = 255;

export const getStaffMemberByIdResponseAddressCityMax = 255;

export const getStaffMemberByIdResponseAddressStateMax = 2;

export const getStaffMemberByIdResponseAddressZipMax = 10;

export const getStaffMemberByIdResponseAddressCountryMax = 100;



export const getStaffMemberByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getStaffMemberByIdResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getStaffMemberByIdResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getStaffMemberByIdResponseAddressCityMax).nullish(),
  "state": zod.string().max(getStaffMemberByIdResponseAddressStateMax).nullish(),
  "zip": zod.string().max(getStaffMemberByIdResponseAddressZipMax).nullish(),
  "country": zod.string().max(getStaffMemberByIdResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "roles": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})).nullish(),
  "isCurrentUser": zod.boolean(),
  "isOwner": zod.boolean(),
  "canRemove": zod.boolean(),
  "canEditRole": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_STAFF_UPDATE
 */
export const updateStaffMemberParams = zod.object({
  "id": zod.string().uuid()
})

export const updateStaffMemberBodyFirstNameMax = 255;

export const updateStaffMemberBodyLastNameMax = 255;

export const updateStaffMemberBodyPhoneMax = 20;

export const updateStaffMemberBodyEmailMax = 255;

export const updateStaffMemberBodyAddressAddressLine1Max = 255;

export const updateStaffMemberBodyAddressAddressLine2Max = 255;

export const updateStaffMemberBodyAddressCityMax = 255;

export const updateStaffMemberBodyAddressStateMax = 2;

export const updateStaffMemberBodyAddressZipMax = 10;

export const updateStaffMemberBodyAddressCountryMax = 100;



export const updateStaffMemberBody = zod.object({
  "firstName": zod.string().max(updateStaffMemberBodyFirstNameMax).nullish(),
  "lastName": zod.string().max(updateStaffMemberBodyLastNameMax).nullish(),
  "phone": zod.string().max(updateStaffMemberBodyPhoneMax).nullish(),
  "email": zod.string().max(updateStaffMemberBodyEmailMax).nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateStaffMemberBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateStaffMemberBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateStaffMemberBodyAddressCityMax).nullish(),
  "state": zod.string().max(updateStaffMemberBodyAddressStateMax).nullish(),
  "zip": zod.string().max(updateStaffMemberBodyAddressZipMax).nullish(),
  "country": zod.string().max(updateStaffMemberBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional()
})

export const updateStaffMemberResponseAddressAddressLine1Max = 255;

export const updateStaffMemberResponseAddressAddressLine2Max = 255;

export const updateStaffMemberResponseAddressCityMax = 255;

export const updateStaffMemberResponseAddressStateMax = 2;

export const updateStaffMemberResponseAddressZipMax = 10;

export const updateStaffMemberResponseAddressCountryMax = 100;



export const updateStaffMemberResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateStaffMemberResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateStaffMemberResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateStaffMemberResponseAddressCityMax).nullish(),
  "state": zod.string().max(updateStaffMemberResponseAddressStateMax).nullish(),
  "zip": zod.string().max(updateStaffMemberResponseAddressZipMax).nullish(),
  "country": zod.string().max(updateStaffMemberResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "roles": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})).nullish(),
  "isCurrentUser": zod.boolean(),
  "isOwner": zod.boolean(),
  "canRemove": zod.boolean(),
  "canEditRole": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_STAFF_DELETE
 */
export const removeStaffMemberParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_STAFF_LIST
 */
export const listStaffMembersQueryPageDefault = 1;export const listStaffMembersQueryPageSizeDefault = 25;export const listStaffMembersQueryActiveOnlyDefault = true;

export const listStaffMembersQueryParams = zod.object({
  "page": zod.number().default(listStaffMembersQueryPageDefault),
  "pageSize": zod.number().default(listStaffMembersQueryPageSizeDefault),
  "search": zod.string().optional(),
  "activeOnly": zod.boolean().default(listStaffMembersQueryActiveOnlyDefault)
})

export const listStaffMembersResponseItemsItemAddressAddressLine1Max = 255;

export const listStaffMembersResponseItemsItemAddressAddressLine2Max = 255;

export const listStaffMembersResponseItemsItemAddressCityMax = 255;

export const listStaffMembersResponseItemsItemAddressStateMax = 2;

export const listStaffMembersResponseItemsItemAddressZipMax = 10;

export const listStaffMembersResponseItemsItemAddressCountryMax = 100;



export const listStaffMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(listStaffMembersResponseItemsItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listStaffMembersResponseItemsItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listStaffMembersResponseItemsItemAddressCityMax).nullish(),
  "state": zod.string().max(listStaffMembersResponseItemsItemAddressStateMax).nullish(),
  "zip": zod.string().max(listStaffMembersResponseItemsItemAddressZipMax).nullish(),
  "country": zod.string().max(listStaffMembersResponseItemsItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "roles": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})).nullish(),
  "isCurrentUser": zod.boolean(),
  "isOwner": zod.boolean(),
  "canRemove": zod.boolean(),
  "canEditRole": zod.boolean()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_STAFF_CREATE
 */
export const createStaffMemberBody = zod.object({
  "firstName": zod.string(),
  "lastName": zod.string(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_STAFF_UPDATE
 */
export const updateStaffMemberRoleParams = zod.object({
  "id": zod.string().uuid()
})

export const updateStaffMemberRoleBody = zod.object({
  "roleCode": zod.string()
})

export const updateStaffMemberRoleResponseAddressAddressLine1Max = 255;

export const updateStaffMemberRoleResponseAddressAddressLine2Max = 255;

export const updateStaffMemberRoleResponseAddressCityMax = 255;

export const updateStaffMemberRoleResponseAddressStateMax = 2;

export const updateStaffMemberRoleResponseAddressZipMax = 10;

export const updateStaffMemberRoleResponseAddressCountryMax = 100;



export const updateStaffMemberRoleResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid().nullish(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateStaffMemberRoleResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateStaffMemberRoleResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateStaffMemberRoleResponseAddressCityMax).nullish(),
  "state": zod.string().max(updateStaffMemberRoleResponseAddressStateMax).nullish(),
  "zip": zod.string().max(updateStaffMemberRoleResponseAddressZipMax).nullish(),
  "country": zod.string().max(updateStaffMemberRoleResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "roles": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish()
})).nullish(),
  "isCurrentUser": zod.boolean(),
  "isOwner": zod.boolean(),
  "canRemove": zod.boolean(),
  "canEditRole": zod.boolean()
})

